import { CardContent, Typography } from '@mui/material'
import React from 'react'
import { StyledCard } from '../StyledCard'

export const TimeMaterialCard = (props: any) => {
  const { timeMaterial } = props
  return <StyledCard>
    <CardContent>
      <Typography variant='h5'>
        {timeMaterial?.name}
      </Typography>
      <strong>T&M Number:</strong> {timeMaterial?.baseReportNumber} <br />
      <strong>Project Name:</strong> {timeMaterial?.project?.projectName} <br />
      <strong>Project Number:</strong> {timeMaterial?.project?.projectNumber} <br />
      <strong>Client Name:</strong> {timeMaterial?.project?.clientName} <br />
      <strong>Client Email(s):</strong> {timeMaterial?.project?.clientEmails} <br />
    </CardContent>
  </StyledCard>
}